'use client';

import { Wizard } from '@/components/wizard/Wizard';

import { CreateGraphFlow, type GraphWizardState } from './createGraphFlow';

interface CreateGraphWizardProps {
  workspaceId: string;
  dashboardId: string;
  graphId?: string;
  onSave: () => Promise<void>;
  onAbort: () => void;
}

export function CreateGraphWizard(props: CreateGraphWizardProps) {
  const save = async () => {
    await props.onSave();
    return true;
  };

  return (
    <Wizard<GraphWizardState>
      onAbort={props.onAbort}
      onFinish={save}
      initialState={{
        workspaceId: props.workspaceId,
        dashboardId: props.dashboardId,
        graphId: props.graphId,
        title: 'Untitled Graph',
        chartType: 'BAR',
        sqlQuery: '-- Write your SQL query here\n',
        columnMapping: {},
        layout: { x: 0, y: 0, w: 2, h: 1 },
      }}
      flow={[CreateGraphFlow]}
      title={props.graphId ? 'Edit Graph' : 'Create Graph'}
    />
  );
}
